
export default function HeadTitle({ title }) {
   return (
      <div style={{ background: 'url(/img/leaves.png)', backgroundPosition: 'center center' }} className='p-5 text-center'>
         <h1 className="fw-bold" >{title}</h1>
      </div>
   )
}
